import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { Box, Chip, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  getSmeLeads,
  getSmeSchedules,
} from "../../../../redux/features/smeSlice";
import { SME_TOPIC_SCHEDULES_HEAD } from "../../../../components/datagrid/sme/smeSchedulesTableHead";
import AddSchedule from "./AddSchedule";
import UpdateSmeSchedule from "./UpdateSmeSchedule";
import { useLocation } from "react-router-dom";
import DeleteTopic from "./DeleteSchedule";
import { savePaginationData } from "../../../../redux/features/globalDatagridSlice";
import {
  getAddedTopics,
  getSubjectsUnderBatchId,
} from "../../../../redux/features/batchSlice";

const SMESchedules = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const courseenrollmentId = searchParams.get("courseenrollmentId");
  const studentname = searchParams.get("studentname");
  const phone = searchParams.get("phone");
  const course = searchParams.get("course");
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { smeTopicSchedules, loading } = useSelector((state) => state.sme);
  const { addedTopics } = useSelector((state) => state.batch);
  const BatchID = searchParams.get("BatchID");

  const { batchDetails } = location.state || {};

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
    filter: search,
    status: 0,
    course_enrollment_id: courseenrollmentId,
  };

  useEffect(() => {
    if (pageNum && gridSize && !BatchID) {
      dispatch(
        savePaginationData({
          ...paginationData,
          openAnchor: false,
        })
      );
      dispatch(getSmeSchedules(data));
    }
  }, [pageNum, gridSize, search]);

  const dataParams = {
    batch_id: BatchID,
    page: pageNum,
    limit: gridSize,
    search: search,
  };

  useEffect(() => {
    if (BatchID && pageNum && gridSize) {
      dispatch(getAddedTopics(dataParams));
    }
  }, [BatchID, pageNum, gridSize, search]);

  return (
    <GlobalWrapper
      title={"SME Schedules"}
      actions={
        <AddSchedule
          dispatchdata={data}
          courseenrollmentId={courseenrollmentId}
          BatchID={BatchID}
          dataParams={dataParams}
        />
      }
    >
      {BatchID && (
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={1}
          sx={{ marginBottom: 2 }}
        >
          <Chip
            label={`Batch : ${batchDetails?.course_batch_name}`}
            variant="filled"
            color="secondary"
            size="medium"
          />
          <Chip
            label={`Course : ${batchDetails?.courseAvailable}`}
            variant="filled"
            color="secondary"
            size="medium"
          />
          <Chip
            label={`Class : ${batchDetails?.className}`}
            variant="filled"
            color="secondary"
            size="medium"
          />
          <Chip
            label={`Syllabus : ${batchDetails?.syllabusName}`}
            variant="filled"
            color="secondary"
            size="medium"
          />
          <Chip
            label={`Capacity : ${batchDetails?.course_batch_capacity}`}
            variant="filled"
            color="secondary"
            size="medium"
          />
        </Stack>
      )}
      {!BatchID && (
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={1}
          sx={{ marginBottom: 2 }}
        >
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#1E91D6,#141B41)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Name : {studentname}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#1E91D6,#141B41)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Phone Number : {phone}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#1E91D6,#141B41)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Course : {course}
          </Box>
        </Stack>
      )}
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={SME_TOPIC_SCHEDULES_HEAD}
          rows={BatchID ? addedTopics.data || [] : smeTopicSchedules.data || []}
          meta={
            BatchID
              ? addedTopics?.meta?.totalRecords || 0
              : smeTopicSchedules?.meta?.totalRecords || 0
          }
          rowUniqueId="sl_no"
          loading={loading}
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.chapter} />
              <GlobalAnchorList
                component={
                  <UpdateSmeSchedule
                    rowData={rowData}
                    leadId={courseenrollmentId}
                    dispatchdata={data}
                  />
                }
                label=""
              />
              <GlobalAnchorList
                component={
                  <DeleteTopic
                    rowData={rowData}
                    id={rowData?.sme_schedules_topic_id}
                    data={data}
                  />
                }
                label=""
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default SMESchedules;
